import { boot } from 'quasar/wrappers'
import { empty, isTrue } from 'src/utils/variables'
import { getPlatformLayout } from 'src/modules/app/layouts'

const envVars = {
  DEBUG_LEVEL: process.env.DEBUG_LEVEL,
  DISABLE_CONSOLE: process.env.DISABLE_CONSOLE,
  BUILD_DATE: process.env.BUILD_DATE,
  XSRF_COOKIE_NAME: process.env.XSRF_COOKIE_NAME,
  WITH_CREDENTIALS: process.env.WITH_CREDENTIALS,
  API_ENTRYPOINT: process.env.API_ENTRYPOINT,
  APTELECARE_HOMEPAGE: process.env.APTELECARE_HOMEPAGE,
  SENTRY_DSN: process.env.SENTRY_DSN,
  SENTRY_ENVIRONMENT: process.env.SENTRY_ENVIRONMENT,
  SENTRY_AUTO_SESSION_TRACKING: process.env.SENTRY_AUTO_SESSION_TRACKING,
  SENTRY_TRACES_SAMPLE_RATE: process.env.SENTRY_TRACES_SAMPLE_RATE,
  SENTRY_REPLAYS_SESSION_SAMPLE_RATE: process.env.SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
  SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE: process.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE
}

// Override environments variables by those defined by the reverse proxy in the index.html sent to the end-user
for (const key in window.appConfig) {
  if (!empty(window.appConfig[key]) && window.appConfig[key] !== '__' + key + '__') {
    envVars[key] = window.appConfig[key]
  }
}

const branding = new URLSearchParams(window.location.search).get('branding')

export const config = {
  env: process.env.NODE_ENV,
  version: process.env.APP_VERSION,
  buildDate: envVars.BUILD_DATE,
  debugLevel: envVars.DEBUG_LEVEL,
  disableConsole: isTrue(envVars.DISABLE_CONSOLE),
  aptelecareHomepage: envVars.APTELECARE_HOMEPAGE,
  session: {
    timeRemainingBeforeUserWarn: 300 // seconds
  },
  api: {
    baseURL: envVars.API_ENTRYPOINT,
    xsrfCookieName: envVars.XSRF_COOKIE_NAME,
    withCredentials: isTrue(envVars.WITH_CREDENTIALS),
    withXSRFToken: isTrue(envVars.WITH_CREDENTIALS)
  },
  theme: {
    branding,
    ...getPlatformLayout(branding)
  },
  sentry: {
    // Leave it empty to disable Sentry
    // Get it at https://healabs.sentry.io/settings/projects/auth-spa/keys/
    dsn: envVars.SENTRY_DSN,
    environment: envVars.SENTRY_ENVIRONMENT || 'development',
    autoSessionTracking: isTrue(envVars.SENTRY_AUTO_SESSION_TRACKING ?? false),
    // Set tracesSampleRate to 1.0 to capture 100%  of transactions for performance monitoring.
    // We recommend adjusting this value in production
    // Default to 1.0, (it means 100% of transactions are sent to sentry)
    tracesSampleRate: !empty(envVars.SENTRY_TRACES_SAMPLE_RATE) ? parseFloat(envVars.SENTRY_TRACES_SAMPLE_RATE) : 1.0,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    // Default to 0.1
    replaysSessionSampleRate: !empty(envVars.SENTRY_REPLAYS_SESSION_SAMPLE_RATE) ? parseFloat(envVars.SENTRY_REPLAYS_SESSION_SAMPLE_RATE) : 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    // Default to 1.0
    replaysOnErrorSampleRate: !empty(envVars.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE) ? parseFloat(envVars.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE) : 1.0
  }
}

export const theme = config.theme

export default boot(({ app }) => {
  app.config.globalProperties.$config = config
})
